import React from 'react';
import PropTypes from 'prop-types';
import 'react-select/dist/react-select.css';
import './Home.scss';
import City from './components/City';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.onChangeSearch = this.onChangeSearch.bind(this);
    this.state = {
      searchCitySelected: null,
    };
  }

  static propTypes = {
    history: PropTypes.object,
    cities: PropTypes.array,
    getTours: PropTypes.func,
  };

  componentWillMount() {
  }

  componentWillReceiveProps() {
  }

  onChangeSearch(searchCitySelected) {
    const {history} = this.props;
    this.setState({searchCitySelected}, () => {
      if (this.state.searchCitySelected) {
        this.props.getTours(this.state.searchCitySelected.value, history);
      } else
        this.props.getTours(null, history)
    })
  }

  render() {
    const {
      cities
    } = this.props;
    return (
      <div className="home">
        <h2 className="home__title">SELECT YOUR DESTINATION</h2>
        <ul className="city__list">
          {cities.map((item) => {
            return (
              <City
                key={`city-item-id-${item.id}`}
                {...item}
              />
            )
          })}
        </ul>
      </div>
    )
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/app/containers/Home/Component.js